import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/api/api";

export function useAnimalUpdateRecord(id?: string) {
  return useQuery({
    queryKey: ["adminAnimal", id],
    enabled: Boolean(id),
    queryFn: async () => {
      const response = await apiClient.get(`/animals/animal/${id}`);
      if (!response.data) throw new Error("Animal not found");
      return response.data;
    },
  });
}
